function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_16190_21136)"
}, React.createElement("path", {
  d: "M21.5694 13.3923C21.3506 13.6111 21.0539 13.734 20.7445 13.734H7.69648C6.65709 13.734 6.13656 12.4773 6.87152 11.7423L11.004 7.60991C11.1032 7.51064 11.226 7.43812 11.3609 7.39911L11.3915 7.39026C11.6474 7.31623 11.8473 7.11577 11.9205 6.85963C11.9639 6.70797 12.0526 6.57318 12.1747 6.47333L14.1384 4.8676C14.6672 4.33885 15.5275 3.9467 16.0563 4.47544L17.8402 6.2594C18.2258 6.64497 18.3378 7.23685 18.119 7.7323C18.0015 7.99838 18.0608 8.31544 18.2666 8.5212C18.4724 8.72701 18.7895 8.78634 19.0555 8.66877C19.5511 8.44991 20.1429 8.56199 20.5284 8.94752L22.3124 10.7315C22.8411 11.2603 22.8411 12.1206 22.3124 12.6494L21.5694 13.3923Z",
  fill: "url(#paint0_linear_16190_21136)"
}), React.createElement("path", {
  d: "M22.3907 10.6526L20.6068 8.86862C20.2213 8.48309 19.6294 8.37102 19.1339 8.58988C18.8678 8.70745 18.5508 8.64811 18.345 8.44231C18.1392 8.23654 18.0799 7.91949 18.1974 7.65341C18.4162 7.158 18.3042 6.56607 17.9186 6.18051L16.1347 4.39654C15.6059 3.86784 14.7456 3.8678 14.2168 4.39654L12.3249 6.28848C12.1061 6.50728 11.9832 6.80402 11.9832 7.11344V12.4884C11.9832 13.1328 12.5055 13.6551 13.1498 13.6551H20.8228C21.1322 13.6551 21.4289 13.5322 21.6477 13.3134L22.3907 12.5705C22.9194 12.0417 22.9194 11.1814 22.3907 10.6526Z",
  fill: "url(#paint1_linear_16190_21136)"
}), React.createElement("path", {
  d: "M11.1553 7.45884L11.9832 8.28762L17.541 13.472L18.6014 13.4985L11.9872 6.62695L11.1553 7.45884Z",
  fill: "#FEE682"
}), React.createElement("path", {
  d: "M11.9871 6.62695L11.9832 6.63087V8.28766L17.3457 13.6558H19.0086L11.9871 6.62695Z",
  fill: "#FDD034"
}), React.createElement("path", {
  d: "M11.9833 23.9991H5.35616C4.60839 23.9991 4 23.3907 4 22.6429V20.1201C4 19.5749 4.33929 19.0771 4.84431 18.8815C5.11565 18.7764 5.29788 18.5103 5.29788 18.2193C5.29788 17.9282 5.11561 17.6621 4.84435 17.557C4.33933 17.3615 4 16.8638 4 16.3185V13.7956C4 13.0478 4.60839 12.4395 5.35616 12.4395H21.8595C22.6073 12.4395 23.2157 13.0478 23.2157 13.7956V16.3185C23.2157 16.8637 22.8764 17.3615 22.3713 17.5571C22.1 17.6621 21.9178 17.9282 21.9178 18.2193C21.9178 18.5103 22.1 18.7764 22.3713 18.8815C22.8764 19.0771 23.2157 19.5748 23.2157 20.1201V22.6429C23.2157 23.9991 15.2941 23.4697 11.9833 23.9991Z",
  fill: "#FFF4F4"
}), React.createElement("path", {
  d: "M23.1558 17.5571C23.6608 17.3615 24.0001 16.8637 24.0001 16.3185V13.7956C24.0001 13.0478 23.3918 12.4395 22.644 12.4395H19.8874L19.2943 12.8422L18.7109 12.4395H11.9834V23.9991H18.706L19.2698 23.8716L19.8825 23.9991H22.644C23.3918 23.9991 24.0001 23.3907 24.0001 22.6429V20.1201C24.0001 19.5749 23.6609 19.0771 23.1558 18.8815C22.8845 18.7764 22.7022 18.5103 22.7022 18.2193C22.7022 17.9282 22.8845 17.6621 23.1558 17.5571Z",
  fill: "#DFE2F6"
}), React.createElement("path", {
  d: "M16.6177 16.166L11.9833 16.3523H8.11768V15.1758H11.9833L16.6373 15.5679L16.6177 16.166Z",
  fill: "#DFE2F6"
}), React.createElement("path", {
  d: "M16.7843 18.5881L11.9833 18.7058H8.11768V17.5293H11.9833L16.7255 17.9149L16.7843 18.5881Z",
  fill: "#DFE2F6"
}), React.createElement("path", {
  d: "M16.5098 20.822L11.9833 21.0573H8.11768V19.8809H11.9833L16.7059 20.1423L16.5098 20.822Z",
  fill: "#DFE2F6"
}), React.createElement("path", {
  d: "M18.7058 12.4395H19.8823V23.9991H18.7058V12.4395Z",
  fill: "#FDD034"
}), React.createElement("path", {
  d: "M11.9832 15.1758H16.9411V16.3523H11.9832V15.1758Z",
  fill: "#B4B9F1"
}), React.createElement("path", {
  d: "M11.9832 17.5293H16.9411V18.7058H11.9832V17.5293Z",
  fill: "#B4B9F1"
}), React.createElement("path", {
  d: "M11.9832 19.8809H16.9411V21.0573H11.9832V19.8809Z",
  fill: "#B4B9F1"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_16190_21136",
  x1: 23.0664,
  y1: 4.22461,
  x2: 9.96482,
  y2: 18.4472,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("linearGradient", {
  id: "paint1_linear_16190_21136",
  x1: 23.0039,
  y1: 4,
  x2: 10.8221,
  y2: 11.8927,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F573D9"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("clipPath", {
  id: "clip0_16190_21136"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(4 4)"
})));

var SvgTprlActive = function SvgTprlActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTprlActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tprl_active.2ac566e3.svg";
export { ForwardRef as ReactComponent };